import firebase from 'firebase/compat/app'
import 'firebase/messaging' // required import for FCM functionality
import { subscribe } from './data'
import { notifyIncident } from './notifications'

export default async function initialiseFirebase({
  FIREBASE_CONFIG,
  FIREBASE_PUBLIC_VAPID_KEY
}: {
  FIREBASE_CONFIG: string
  FIREBASE_PUBLIC_VAPID_KEY: string
}) {
  try {
    const hasNotifications = firebase.messaging?.isSupported()

    if (hasNotifications) {
      if (firebase.apps.length) {
        firebase.app()
      } else {
        firebase.initializeApp(FIREBASE_CONFIG)
      }
      const messaging = firebase.messaging()
      const currentToken = await messaging.getToken({
        vapidKey: FIREBASE_PUBLIC_VAPID_KEY
      })
      await subscribe(currentToken)

      messaging.onMessage((payload) => {
        switch (payload.data.type) {
          case 'incident':
            notifyIncident(payload)
            break
          default:
            break
        }
      })
    }
  } catch (error) {
    console.error(error)
  }
}
